<script>
import {defineComponent, ref, watch, computed} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import {useI18n} from "vue-i18n";
import {useServices} from "@/hooks/services";

import Button from "primevue/button";
import DataView from "primevue/dataview";
import Paginator from "primevue/paginator";


export default defineComponent({
  layout: { name: 'AdminLayout'},
  components: {Button, DataView, Paginator},
  async beforeRouteEnter(to, from, next) {
    try {
      const {loadServices} = useServices();
      await loadServices({
        page: 1,
        type: to.params.type,
      });
    } catch (e) {
      console.error(e);
    }

    next();
  },
  setup() {
    const {services, loadServices} = useServices();
    const {t} = useI18n();

    const store = useStore();
    const route = useRoute();
    const lang = computed(() => store.getters.getLang);

    const nameField = computed(() => `name_${lang.value}`);
    const descriptionField = computed(() => `description_${lang.value}`);

    const first = ref(0);

    const load = async () => {
      await loadServices({
        type: route.params.type,
        page: ((first.value / (services.value?.data?.pagination?.per_page ?? 1)) + 1)
      });
      window.scrollTo(0,0);
    };

    watch((first), async (index) => {
      await load();
    });
    watch(
        () => route.params.type,
        async (type) => {
          if (!type) return;
          await load()
        }
    );

    return {services, first, t, nameField, descriptionField};
  }
});

</script>

<template>
  <template v-if="services?.data?.data ? services.data.data.length : false">
    <section class="py-2 mb-3">
      <DataView :value="services?.data?.data ?? []">
        <template #list="slotProps">
          <div class="col-12">
            <div class="flex flex-column xl:flex-row xl:align-items-start p-4 gap-4">
              <img
                  class="w-9 sm:w-16rem xl:w-14rem shadow-2 block xl:block mx-auto border-round"
                  :src="slotProps.data.photo?.original_url"
                  :alt="slotProps.data.service_name"
              />
              <div class="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                <div class="flex flex-column align-items-center sm:align-items-start gap-3">
                  <div class="text-2xl font-bold text-900">
                    <router-link class="color-primary" :to="{name: 'service-view', params: {id: slotProps.data.id}}">
                      {{ slotProps.data[nameField] }}
                    </router-link>
                  </div>
                  <div class="flex align-items-center xl:w-5 gap-3">
                  <span class="flex align-items-center color-black-40 gap-2">
                    <span class="font-semibold" v-html="slotProps.data[descriptionField]"></span>
                  </span>
                  </div>
                </div>
                <div class="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
                  <template v-if="slotProps.data.cost">
                    <span class="flex color-black-80 text-xl font-bold" style="white-space: nowrap">{{ slotProps.data.cost }} Р.</span>
                  </template>
                  <template v-else>
                    <span class="color-black-80 text-xl font-bold" style="white-space: nowrap; text-align: right">{{ t('tables.tariffs.cost') }}</span>
                    <span style="text-align: right">Указывается в категории</span>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </template>
      </DataView>

      <Paginator
          v-model:first="first"
          :rows="services?.data?.pagination?.per_page ?? 0"
          :totalRecords="services?.data?.pagination?.total ?? 0"
          class="justify-content-start"
      ></Paginator>
    </section>
  </template>
  <template v-else>
    <section class="py-2 mb-3">
      <div class="flex justify-content-center">
        <span>{{ t('empty-data') }}</span>
      </div>
    </section>
  </template>
</template>

<style scoped>

</style>